import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { users } from "../../rbac-consts";
import { default as SuperAdminClientDetailsContainer } from "./superAdmin/ClientDetailsContainer";
import { default as AdminClientDetailsContainer } from "./admin/ClientDetailsContainer";

const ClientDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={users.SUPER_ADMIN}
        yes={() => (
          <SuperAdminClientDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={users.ADMIN}
        yes={() => (
          <AdminClientDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default ClientDetailsWrapper;
